/**
 * @generated SignedSource<<150ae4cd6382b09734f429980f2f79a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
import { FragmentRefs } from "relay-runtime";
export type useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot$data = {
  readonly course: {
    readonly courseBucket: {
      readonly id: string;
      readonly slotDurations: ReadonlyArray<{
        readonly startSlot: {
          readonly course: {
            readonly description: string | null | undefined;
            readonly id: string;
            readonly name: string;
          };
          readonly endSlotOptions: {
            readonly edges: ReadonlyArray<{
              readonly allowedPlayerCounts: ReadonlyArray<number | null | undefined> | null | undefined;
              readonly durationMins: number | null | undefined;
              readonly node: {
                readonly availability: SlotAvailability;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly time: string;
        };
      } | null | undefined>;
    } | null | undefined;
    readonly description: string | null | undefined;
    readonly facility: {
      readonly copyOverrides: {
        readonly course: {
          readonly singular: string;
        } | null | undefined;
      };
      readonly publicBookingPermissionSet: {
        readonly customerCanSelectCourt: boolean | null | undefined;
      } | null | undefined;
    };
    readonly id: string;
    readonly name: string;
  };
  readonly endSlotOptions: {
    readonly edges: ReadonlyArray<{
      readonly allowedPlayerCounts: ReadonlyArray<number | null | undefined> | null | undefined;
      readonly durationMins: number | null | undefined;
      readonly node: {
        readonly availability: SlotAvailability;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot";
};
export type useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot$key = {
  readonly " $data"?: useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "bookingId",
      "variableName": "bookingId"
    },
    {
      "kind": "Variable",
      "name": "bookingType",
      "variableName": "bookingType"
    },
    {
      "kind": "Variable",
      "name": "memberId",
      "variableName": "memberId"
    }
  ],
  "concreteType": "EndSlotOptionsConnection",
  "kind": "LinkedField",
  "name": "endSlotOptions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EndSlotOptionsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationMins",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowedPlayerCounts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlot",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availability",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "agendaId"
    },
    {
      "kind": "RootArgument",
      "name": "bookingId"
    },
    {
      "kind": "RootArgument",
      "name": "bookingType"
    },
    {
      "kind": "RootArgument",
      "name": "memberId"
    },
    {
      "kind": "RootArgument",
      "name": "startTime"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PublicBookingPermissionSet",
              "kind": "LinkedField",
              "name": "publicBookingPermissionSet",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customerCanSelectCourt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FacilityCopyOverrides",
              "kind": "LinkedField",
              "name": "copyOverrides",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NounOverride",
                  "kind": "LinkedField",
                  "name": "course",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "singular",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseBucket",
          "kind": "LinkedField",
          "name": "courseBucket",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "agendaId",
                  "variableName": "agendaId"
                },
                {
                  "kind": "Variable",
                  "name": "startsAt",
                  "variableName": "startTime"
                }
              ],
              "concreteType": "SlotDurations",
              "kind": "LinkedField",
              "name": "slotDurations",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeSlot",
                  "kind": "LinkedField",
                  "name": "startSlot",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "time",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Course",
                      "kind": "LinkedField",
                      "name": "course",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v2/*: any*/),
                        (v3/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TimeSlot",
  "abstractKey": null
};
})();

(node as any).hash = "6bad37daafae142ce7f322b228955edc";

export default node;
